// Page food truck : clic sur une vignette → remplace l'image principale
function foodtruckGallery() {
    const main = document.querySelector('.foodtruck_gallery_main-js');
    if (!main) return;

    const thumbs = document.querySelectorAll('.foodtruck_gallery_thumb-js');

    thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
            main.src = thumb.dataset.src;
            main.alt = thumb.dataset.alt || '';

            thumbs.forEach(function (item) {
                item.classList.toggle('active', item === thumb);
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', foodtruckGallery);
